export default {
  namespaced: true,

  state: {
    isComposeLoading: true,
  },

  mutations: {
    setComposeLoading(state, isComposeLoading) {
      state.isComposeLoading = isComposeLoading;
    },
  },

  getters: {
    isComposeLoading(state) {
      return state.isComposeLoading;
    },
  },
};
